//=====================================================
//　入力項目ラベル
//=====================================================

import { InputTag } from "../utils/ConstCommon";

interface IFProps {
    title: string,
    tag?: InputTag
}

export function LblInput(props: IFProps){

    return (
        <div className="input-title">
            <label htmlFor="name">{props.title}</label>
            {props.tag === InputTag.Required && <span className="tag input-tag tag-red">必須</span>}
            {props.tag === InputTag.Optional && <span className="tag input-tag tag-gray">任意</span>}
        </div>
    )

}